import { render, staticRenderFns } from "./TraxSettingTaskCrud.vue?vue&type=template&id=724425be"
import script from "./TraxSettingTaskCrud.vue?vue&type=script&lang=js"
export * from "./TraxSettingTaskCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports